export default "__VITE_ASSET__8cb6c8df__"